module.exports = __webpack_public_path__ + "static/img/monitiorB.bc35ae4d.png";